import React from 'react';
import hoc from './FieldHOC';
import HelpText from './HelpText';

class TextArea extends React.Component{

  onChange = (e) => {
    this.props.onChange(e.target.value);
  }

  render(){
    let field = this.props.field;
    return <div>
      <label htmlFor={this.props.id}>{this.props.title || field.get('title')}</label>
      <HelpText field={field} helpText={this.props.helpText} />
      {this.props.errorComponent}
      <textarea aria-label={this.props.title || field.get('title')} value={this.props.value} disabled={this.props.disabled} onChange={this.onChange} tabIndex={this.props.tabIndex} placeholder={this.props.field.prop('hintText')} name={this.props.name} id={this.props.id} className="form-control" rows={7}></textarea>
    </div>;
  }

}

export default hoc(TextArea);
